var map = {
	"./Profile.png": 5239,
	"./TravelGo.png": 2363,
	"./appstore.svg": 9845,
	"./bottomrightdesign.png": 5224,
	"./calendar.png": 3165,
	"./chart.png": 2676,
	"./cover.png": 4503,
	"./facebook.svg": 1693,
	"./favourite.png": 8588,
	"./footer-logo.svg": 8105,
	"./greeceexample.png": 2386,
	"./history.png": 1684,
	"./hotel.png": 9341,
	"./indonesia.png": 4895,
	"./indonesia2.png": 270,
	"./instagram.svg": 2770,
	"./japan.png": 4067,
	"./loation.png": 3965,
	"./location-2.png": 4234,
	"./location.png": 6780,
	"./mail.png": 9698,
	"./mountains.png": 8580,
	"./navigate.png": 1381,
	"./newzealand.png": 2453,
	"./person.png": 1641,
	"./playstore.svg": 8591,
	"./reviewbg.png": 5859,
	"./send.png": 1037,
	"./step1.png": 1894,
	"./step2.png": 190,
	"./step3.png": 2555,
	"./thailand.png": 8970,
	"./ticket.png": 6093,
	"./tour.png": 5497,
	"./world-map-2.png": 4371,
	"./world-map.png": 1247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;